/** @jsxImportSource @emotion/react */

import { FC } from "react";
import { ColorAlias, getThemeColorFromAlias, theme } from "../../theme";

interface LogoProps {
  onClick?: () => void;
  color?: ColorAlias;
}

const SompoLogo: FC<LogoProps> = ({ onClick, color }) => {
  const logoColor = color
    ? getThemeColorFromAlias(color, theme.colors)
    : getThemeColorFromAlias("Green", theme.colors);
  return (
    <span onClick={onClick}>
      <svg
        height="25"
        viewBox="0 0 171 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.1183 6.30103C10.0391 8.19916 7.97218 11.5736 7.97218 15.4543C7.97218 21.4018 12.7808 26.2104 18.7283 26.2104C21.217 26.2104 23.5369 25.3668 25.3507 23.9326C24.8024 25.3668 24.0431 26.6744 23.1151 27.8133C21.7653 28.3194 20.289 28.5725 18.7283 28.5725C11.5154 28.5725 5.65223 22.7094 5.65223 15.4964C5.65223 12.2907 6.79112 9.33804 8.73144 7.06028C9.78596 6.68065 10.8827 6.46974 12.0215 6.3432C5.31479 6.89155 0 12.5438 0 19.3771C0 26.59 5.86314 32.4532 13.0761 32.4532C20.289 32.4532 26.1521 26.59 26.1521 19.3771C26.1943 12.1642 20.3312 6.30103 13.1183 6.30103Z"
          fill={logoColor}
          fillOpacity="0.28"
        />
        <mask
          id="mask0_1698_817"
          maskUnits="userSpaceOnUse"
          x="0"
          y="6"
          width="27"
          height="27"
        >
          <path
            d="M13.1183 6.30103C10.0391 8.19916 7.97218 11.5736 7.97218 15.4543C7.97218 21.4018 12.7808 26.2104 18.7283 26.2104C21.217 26.2104 23.5369 25.3668 25.3507 23.9326C24.8024 25.3668 24.0431 26.6744 23.1151 27.8133C21.7653 28.3194 20.289 28.5725 18.7283 28.5725C11.5154 28.5725 5.65223 22.7094 5.65223 15.4964C5.65223 12.2907 6.79112 9.33804 8.73144 7.06028C9.78596 6.68065 10.8827 6.46974 12.0215 6.3432C5.31479 6.89155 0 12.5438 0 19.3771C0 26.59 5.86314 32.4532 13.0761 32.4532C20.289 32.4532 26.1521 26.59 26.1521 19.3771C26.1943 12.1642 20.3312 6.30103 13.1183 6.30103Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_1698_817)">
          <path
            d="M26.1943 6.30103H0V32.4953H26.1943V6.30103Z"
            fill={logoColor}
            fillOpacity="1"
          />
        </g>
        <path
          d="M6.9189 14.0202C6.9189 7.65085 12.065 2.46259 18.4343 2.46259C24.8036 2.46259 29.9497 7.60865 29.9497 13.978C29.9497 20.3473 24.8036 25.5355 18.4343 25.5355C12.1072 25.5777 6.9189 20.3895 6.9189 14.0202ZM18.4765 0.944092C11.2635 0.944092 5.40039 6.80723 5.40039 14.0202C5.40039 21.2331 11.2635 27.0962 18.4765 27.0962C25.6894 27.0962 31.5525 21.2331 31.5525 14.0202C31.5525 6.80723 25.6894 0.944092 18.4765 0.944092Z"
          fill={logoColor}
          fillOpacity="1"
        />
        <mask
          id="mask1_1698_817"
          maskUnits="userSpaceOnUse"
          x="5"
          y="0"
          width="27"
          height="28"
        >
          <path
            d="M6.92085 14.02C6.92085 7.65073 12.0669 2.46247 18.4362 2.46247C24.8055 2.46247 29.9516 7.60853 29.9516 13.9778C29.9516 20.3472 24.8055 25.5354 18.4362 25.5354C12.1091 25.5776 6.92085 20.3893 6.92085 14.02ZM18.4784 0.94397C11.2655 0.94397 5.40234 6.80711 5.40234 14.02C5.40234 21.233 11.2655 27.0961 18.4784 27.0961C25.6913 27.0961 31.5545 21.233 31.5545 14.02C31.5545 6.80711 25.6913 0.94397 18.4784 0.94397Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_1698_817)">
          <path
            d="M31.5537 0.94397H5.35938V27.1383H31.5537V0.94397Z"
            fill={logoColor}
            fillOpacity="1"
          />
        </g>
        <path
          d="M7.72091 14.0195C7.72091 8.07196 12.5295 3.26334 18.477 3.26334C24.4245 3.26334 29.2331 8.07196 29.2331 14.0195C29.2331 19.967 24.4245 24.7756 18.477 24.7756C12.5295 24.7756 7.72091 19.967 7.72091 14.0195ZM18.477 2.16663C11.8968 2.16663 6.58203 7.48142 6.58203 14.0616C6.58203 20.6419 11.8968 25.9566 18.477 25.9566C25.0572 25.9566 30.372 20.6419 30.372 14.0616C30.372 7.48142 25.0572 2.16663 18.477 2.16663Z"
          fill={logoColor}
          fillOpacity="1"
        />
        <mask
          id="mask2_1698_817"
          maskUnits="userSpaceOnUse"
          x="6"
          y="2"
          width="25"
          height="24"
        >
          <path
            d="M7.72287 14.0193C7.72287 8.07184 12.5315 3.26322 18.479 3.26322C24.4265 3.26322 29.2351 8.07184 29.2351 14.0193C29.2351 19.9668 24.4265 24.7755 18.479 24.7755C12.5315 24.7755 7.72287 19.9668 7.72287 14.0193ZM18.479 2.1665C11.8988 2.1665 6.58398 7.4813 6.58398 14.0615C6.58398 20.6417 11.8988 25.9565 18.479 25.9565C25.0592 25.9565 30.374 20.6417 30.374 14.0615C30.374 7.4813 25.0592 2.1665 18.479 2.1665Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask2_1698_817)">
          <path
            d="M30.374 2.12427H6.58398V25.9143H30.374V2.12427Z"
            fill={logoColor}
            fillOpacity="1"
          />
        </g>
        <path
          d="M77.1067 11.0671L72.7621 22.2451L68.3753 11.0671H65.2539V24.3541H67.2364V12.7544L71.7919 24.3541H73.7322L78.2456 12.7122V24.3541H80.2281V11.0671"
          fill={logoColor}
          fillOpacity="1"
        />
        <path
          d="M38.1304 22.3292C39.3115 22.8776 40.7457 23.2572 42.2642 23.2572C43.9092 23.2572 45.5965 22.6245 45.5965 21.0216C45.5965 19.6718 44.2467 18.9548 42.6016 18.322L41.3784 17.858C39.7755 17.2253 38.1726 16.2552 38.1726 14.4836C38.1726 11.9527 41.0409 10.8982 43.614 10.8982C44.9637 10.8982 46.1026 11.0669 47.3681 11.4044L47.1993 12.8385C46.1448 12.4589 44.9216 12.2058 43.6561 12.2058C42.0111 12.2058 40.4926 12.8807 40.4926 14.2305C40.4926 15.3272 41.5893 15.9177 43.1078 16.5082L44.2889 16.9722C46.2292 17.6893 47.9586 18.7016 47.9586 20.7263C47.9586 23.2994 45.4699 24.607 42.3907 24.607C41.0831 24.607 39.185 24.3117 38.0039 23.8899"
          fill={logoColor}
          fillOpacity="1"
        />
        <path
          d="M83.1367 24.354V11.067H87.2704C90.1809 11.067 92.8383 11.9106 92.8383 14.9055C92.8383 17.9847 90.2231 19.0814 87.1017 19.0814H85.2879V24.3962M85.2879 17.6894H87.397C89.3373 17.6894 90.5184 16.6771 90.5184 14.9055C90.5184 13.176 89.2108 12.4168 87.3548 12.4168H85.2458L85.2879 17.6894Z"
          fill={logoColor}
          fillOpacity="1"
        />
        <path
          d="M94.2734 17.7311C94.2734 14.0191 96.5512 10.8556 101.022 10.8556C105.578 10.8556 107.771 13.8504 107.771 17.7311C107.771 21.6117 105.451 24.6065 101.022 24.6065C96.5934 24.5644 94.2734 21.443 94.2734 17.7311ZM101.022 23.1302C104.186 23.1302 105.451 20.1776 105.451 17.6889C105.451 15.2002 104.228 12.2476 101.022 12.2476C97.901 12.2476 96.5934 15.2424 96.5934 17.6889C96.5512 20.1354 97.8166 23.1302 101.022 23.1302Z"
          fill={logoColor}
          fillOpacity="1"
        />
        <path
          d="M49.4766 17.7311C49.4766 14.0191 51.7543 10.8556 56.2255 10.8556C60.781 10.8556 62.9744 13.8504 62.9744 17.7311C62.9744 21.6117 60.6545 24.6065 56.2255 24.6065C51.7965 24.5644 49.4766 21.443 49.4766 17.7311ZM56.2255 23.1302C59.3891 23.1302 60.6545 20.1776 60.6545 17.6889C60.6545 15.2002 59.4312 12.2476 56.2255 12.2476C53.1041 12.2476 51.7965 15.2424 51.7965 17.6889C51.7965 20.1354 53.0619 23.1302 56.2255 23.1302Z"
          fill={logoColor}
          fillOpacity="1"
        />
        <path
          d="M118.316 16.3818C117.641 16.1287 117.261 16.0022 116.544 16.0022C115.785 16.0022 114.899 16.2553 114.899 17.2676C114.899 19.0814 118.906 18.6596 118.906 21.7388C118.906 23.7213 117.345 24.5227 115.49 24.5227C114.815 24.5227 114.182 24.3118 113.591 24.1431L113.718 22.8776C114.182 23.0886 114.983 23.3416 115.658 23.3416C116.418 23.3416 117.472 22.9198 117.472 21.8231C117.472 19.7141 113.465 20.3046 113.465 17.3941C113.465 15.7491 114.772 14.8633 116.46 14.8633C117.092 14.8633 117.809 14.9898 118.442 15.2007"
          fill={logoColor}
          fillOpacity="1"
        />
        <path
          d="M120.803 14.9475H126.075V16.1286H122.153V18.8703H125.696V20.0514H122.153V23.1306H126.075V24.3116H120.845"
          fill={logoColor}
          fillOpacity="1"
        />
        <path
          d="M135.314 16.6351C134.64 16.2133 133.965 16.0024 132.741 16.0024C130.59 16.0024 129.156 17.563 129.156 19.6721C129.156 21.8655 130.717 23.3418 132.657 23.3418C133.585 23.3418 133.838 23.2575 134.176 23.1731V20.347H132.193V19.2503H135.483V24.1011C134.977 24.2698 134.091 24.5229 132.615 24.5229C129.662 24.5229 127.68 22.6248 127.68 19.6299C127.68 16.7616 129.789 14.8213 132.615 14.8213C133.965 14.8213 134.597 15.0322 135.357 15.2853"
          fill={logoColor}
          fillOpacity="1"
        />
        <path
          d="M145.144 20.431C145.144 23.0462 143.836 24.4804 141.516 24.4804C139.196 24.4804 137.889 23.0884 137.889 20.431V14.9475H139.238V20.2623C139.238 22.0761 139.787 23.2993 141.516 23.2993C143.246 23.2993 143.794 22.0761 143.794 20.2623V14.9475H145.144"
          fill={logoColor}
          fillOpacity="1"
        />
        <path
          d="M147.463 14.9475H149.741C151.597 14.9475 153.368 15.2428 153.368 17.4784C153.368 18.6172 152.525 19.4187 151.428 19.6296V19.6717C151.85 19.8405 152.061 20.0514 152.356 20.5997L154.127 24.3116H152.609L151.175 21.0637C150.753 20.1358 150.331 20.1358 149.614 20.1358H148.813V24.2695H147.463M148.813 18.9547H149.952C151.217 18.9547 151.976 18.4063 151.976 17.4784C151.976 16.6347 151.344 16.0864 150.078 16.0864H148.813V18.9547Z"
          fill={logoColor}
          fillOpacity="1"
        />
        <path
          d="M159.736 14.7792C162.562 14.7792 164.249 16.846 164.249 19.63C164.249 22.4561 162.604 24.4808 159.736 24.4808C156.868 24.4808 155.223 22.4983 155.223 19.63C155.265 16.846 156.91 14.7792 159.736 14.7792ZM159.736 23.2997C161.887 23.2997 162.815 21.4859 162.815 19.63C162.815 17.7318 161.803 15.9602 159.736 15.9602C157.669 15.9602 156.657 17.7318 156.657 19.63C156.657 21.4859 157.585 23.2997 159.736 23.2997Z"
          fill={logoColor}
          fillOpacity="1"
        />
        <path
          d="M170.41 16.3398C169.735 16.0867 169.356 15.9602 168.639 15.9602C167.879 15.9602 166.994 16.2133 166.994 17.2256C166.994 19.0394 171.001 18.6176 171.001 21.6968C171.001 23.6793 169.44 24.4807 167.584 24.4807C166.909 24.4807 166.276 24.2698 165.686 24.1011L165.812 22.8357C166.276 23.0466 167.078 23.2997 167.753 23.2997C168.512 23.2997 169.609 22.8778 169.609 21.7811C169.609 19.6721 165.602 20.2626 165.602 17.3521C165.602 15.7071 166.909 14.8213 168.596 14.8213C169.229 14.8213 169.946 14.9479 170.579 15.1588"
          fill={logoColor}
          fillOpacity="1"
        />
      </svg>
    </span>
  );
};

export default SompoLogo;
